import T from 'prop-types'
import React from 'react'
import TextOverflow from './TextOverflow'
import { formatBytes } from 'pw-formatters'

class FileUploadProgress extends React.Component {
  static displayName = 'FileUploadProgress'

  static propTypes = {
    file: T.instanceOf(File).isRequired,
    onClick: T.func,
    parsed: T.any,
    progress: T.shape({
      loaded: T.number,
      total: T.number,
      error: T.any
    }),
    selected: T.bool
  }

  static defaultProps = {
    progress: {
      error: null,
      loaded: -1, // bytes
      total: -1 // bytes
    }
  }

  _onClick = () => {
    const { onClick, file } = this.props
    if (onClick) {
      onClick(file)
    }
  }

  render() {
    const { file, selected, progress } = this.props
    const { error, loaded, total } = progress
    const isSelected = selected && !error

    return (
      <div
        className={`file_upload_progress ${isSelected ? 'is_active' : ''} ${error
          ? 'has_error'
          : ''}`}
        onClick={this._onClick}
      >
        {/* <Checkbox
          checked={ isSelected }
        /> */}
        <div>
          <TextOverflow className="file_name">
            {file.name}
          </TextOverflow>
          {error
            ? <div className="file_read_error">
                {error}
              </div>
            : loaded > -1
              ? <div className="file_read_progress">
                  {!error && loaded > -1 && loaded === total
                    ? <span className="icon icon-checkmark" />
                    : null}
                  Loaded {formatBytes(loaded, true)} of{' '}
                  {formatBytes(total, true)}
                </div>
              : 'Loading...'}
        </div>
      </div>
    )
  }
}

export default FileUploadProgress
